<script setup>
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    item: Object,
    value: String
})

const appStore = useAppStore()

const openLink = () => {
    // "If url is an absolute URL, a given base will be ignored."
    // - Which means it's okay to provide the websiteEndpoint for absolute URLs as it will be ignored.
    window.open(new URL(props.value, appStore.websiteEndpoint))
}
</script>

<template>
    <span v-if="value" class="table-cell-hidden-icon-parent">
        <small><code v-if="value">{{ value }}</code></small>
        <a v-if="!item.regex && value" class="bi-box-arrow-up-right table-cell-hidden-icon" href
           @click.prevent="openLink"></a>
    </span>
</template>